import type { Arc, PieArcDatum } from 'd3-shape';

import { INACTIVE_FILL_OPACITY_PIE_CHART } from '../../core/constants.js';
import { useFormatter } from '../context/FormatterContext.js';
import { useSliceHandlers } from '../hooks/useSliceHandlers.js';
import { InternalSliceData } from '../types/internal/pie-chart.js';

export interface PieSliceProps {
  sliceId: string;
  arc: PieArcDatum<InternalSliceData>;
  data: InternalSliceData;
  path: Arc<unknown, PieArcDatum<InternalSliceData>>;
  isHighlihted: boolean;
}

export const PieChartSlice = (props: PieSliceProps) => {
  const { sliceId, arc, data, path, isHighlihted } = props;
  const arcPath = path(arc);
  const formatter = useFormatter();
  const { onMouseClickHandler, onMouseEnterHandler, onMouseLeaveHandler } =
    useSliceHandlers(sliceId, data, formatter);

  return (
    <g
      onMouseEnter={onMouseEnterHandler}
      onClick={onMouseClickHandler}
      onMouseLeave={onMouseLeaveHandler}
    >
      <path
        d={arcPath || ''}
        fill={data.color.Default}
        opacity={isHighlihted ? 0.85 : INACTIVE_FILL_OPACITY_PIE_CHART}
      />
    </g>
  );
};
PieChartSlice['displayName'] = 'PieChartSlice';
